// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"a8a75c6a","570":"33b78ebb"}[chunkId] + ".chunk.css";
};